import logo from 'assets/images/custom/logo.png';
import logo_monochrome from 'assets/images/custom/logo_monochrome.png';

const oldTheme = {
    accentColor: '#E50695',
    alertTextColor: '#FFFFFF',
    backgroundColor: '#F4F1F1',
    badgeFontColor: '#FFFFFF',
    borderColor: '#EAECF4',
    chatFormWrapper: '#F3F7FD',
    chatInputBorder: '#EAECF4',
    dashboardBackground: '#FFFFFF',
    dashboardCalling: '#03AEEE',
    dashboardError: '#EE7E04',
    dashboardPatient: '#AFBD77',
    dashboardWait: '#7D96B5',
    dashboardWarning: '#FEF3F5',
    errorColor: '#F5859E',
    fontFamily: '\'Montserrat\',sans-serif',
    inputBackground: '#FFFFFF',
    inputDisabledBackground: '#F4F5FB',
    inputDisabledColor: '#7D96B5',
    lightColor: '#FFFFFF',
    listingCoverage: '#D8DFE9',
    listingProfessional: '#E3F1F9',
    listingRoom: '#F0EDEB',
    listingUser: '#F0EDEB',
    loginBrandBackground: '#FFFFFF',
    loginFormBackground: '#FFFFFF',
    notificationModalColor: '#FFFFFF',
    opacityColor: '#CFC3BA',
    panelBackgroundColor: '#FFFFFF',
    statusBussy: '#03AEEE',
    warningColor: '#E4C80B'
};

const constantTheme = {
    dangerColor: '#8C182B',
    darkGray: '#B0B0B0',
    disabledBackground: '#E0E0E0',
    disabledColor: '#ABABAB',
    grayBackground: '#F0F0F0',
    statusAvailable: '#008800',
    statusUnavailable: '#8C182B',
    successColor: '#2cc72e',
    turnBackgroundColor: '#3174ad',
    whiteBackground: '#FFFFFF'
};

const newTheme = {
    fontFamily: '\'Montserrat\',sans-serif',
    labelColor: '#92A6C0',
    overPrimaryColor: '#FFFFFF',
    primaryColor: '#003B71',
    primaryLighterColor: '#CCD7E2',
    secondaryColor: '#7D96B5',
    textColor: '#003B71'
};

const configs = {
    logoWidth: '70%',
    menuTextColor: undefined
};

export const baseTheme = {
    ...oldTheme,
    ...constantTheme,
    ...newTheme,
    ...configs
};

export const baseImages = {
    logo,
    logo_height: '60px',
    logo_monochrome
};
